/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Metadata_Add_DescInputs */

const en_options_metadata_add_desc = /** @type {(inputs: Options_Metadata_Add_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add metadata information that will be included with your project exports`)
};

const fr_options_metadata_add_desc = /** @type {(inputs: Options_Metadata_Add_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter des métadonnées qui seront incluses dans les exportations du projet`)
};

const de_options_metadata_add_desc = /** @type {(inputs: Options_Metadata_Add_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fügen Sie Metadateninformationen hinzu, die in Ihre Projektexporte einbezogen werden sollen.`)
};

const it_options_metadata_add_desc = /** @type {(inputs: Options_Metadata_Add_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiungi informazioni sui metadati che saranno incluse nelle esportazioni del tuo progetto`)
};

const ru_options_metadata_add_desc = /** @type {(inputs: Options_Metadata_Add_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Добавьте метаданные, которые будут включены в экспорт вашего проекта.`)
};

const es_options_metadata_add_desc = /** @type {(inputs: Options_Metadata_Add_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agregue información de metadatos que se incluirá con las exportaciones de su proyecto`)
};

const zh_cn2_options_metadata_add_desc = /** @type {(inputs: Options_Metadata_Add_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`添加将包含在项目导出文件中的元数据信息`)
};

const ja_options_metadata_add_desc = /** @type {(inputs: Options_Metadata_Add_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロジェクトのエクスポートに含まれるメタデータ情報を追加します`)
};

const hi_options_metadata_add_desc = /** @type {(inputs: Options_Metadata_Add_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अपने प्रोजेक्ट एक्सपोर्ट के साथ शामिल की जाने वाली मेटाडेटा जानकारी जोड़ें`)
};

const pt_pt2_options_metadata_add_desc = /** @type {(inputs: Options_Metadata_Add_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicione informações de metadados que serão incluídas nas exportações do seu projeto.`)
};

/**
* | output |
* | --- |
* | "Add metadata information that will be included with your project exports" |
*
* @param {Options_Metadata_Add_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_metadata_add_desc = /** @type {((inputs?: Options_Metadata_Add_DescInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Metadata_Add_DescInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_metadata_add_desc(inputs)
	if (locale === "de") return de_options_metadata_add_desc(inputs)
	if (locale === "it") return it_options_metadata_add_desc(inputs)
	if (locale === "ru") return ru_options_metadata_add_desc(inputs)
	if (locale === "es") return es_options_metadata_add_desc(inputs)
	if (locale === "zh-CN") return zh_cn2_options_metadata_add_desc(inputs)
	if (locale === "ja") return ja_options_metadata_add_desc(inputs)
	if (locale === "hi") return hi_options_metadata_add_desc(inputs)
	if (locale === "pt-PT") return pt_pt2_options_metadata_add_desc(inputs)
	return en_options_metadata_add_desc(inputs)
});